import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyBo3O6QfsaaL6U-pV2KCnfk1LGORmAB8V8",
    authDomain: "mvhs-student-utilities.firebaseapp.com",
    projectId: "mvhs-student-utilities",
    storageBucket: "mvhs-student-utilities.firebasestorage.app",
    messagingSenderId: "634473210716",
    appId: "1:634473210716:web:22002a54fa3dc7aa605799",
    measurementId: "G-1EGKFSQD04"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);
export const googleProvider = new GoogleAuthProvider();

googleProvider.addScope('https://www.googleapis.com/auth/classroom.courses');
googleProvider.addScope('https://www.googleapis.com/auth/classroom.coursework.me.readonly');
googleProvider.addScope('https://www.googleapis.com/auth/classroom.student-submissions.me.readonly');
googleProvider.addScope('https://www.googleapis.com/auth/calendar.readonly');